module.exports = __webpack_public_path__ + "static/media/awards_11.463c2360.jpg";